import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../components/LoadingSpinner';

const Login = () => {
  const [credenciales, setCredenciales] = useState({
    nombre_usuario: '',
    contrasena: ''
  });
  const [cargando, setCargando] = useState(false);
  const { login } = useAuth();

  const manejarCambio = (e) => {
    const { name, value } = e.target;
    setCredenciales(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const manejarSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    
    try {
      const resultado = await login(credenciales);
      if (!resultado.exito) {
        setCargando(false);
      }
    } catch (error) {
      setCargando(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 to-secondary-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          {/* Logo placeholder */}
          <div className="mx-auto h-20 w-20 bg-primary-500 rounded-full flex items-center justify-center mb-6">
            <span className="text-white text-2xl font-bold">GP</span>
          </div>
          
          <h2 className="text-3xl font-bold text-gray-900 mb-2">
            GoPhone MDM
          </h2>
          <p className="text-gray-600">
            Sistema de Gestión de Dispositivos Móviles
          </p>
        </div>

        <div className="card">
          <form className="space-y-6" onSubmit={manejarSubmit}>
            <div>
              <label htmlFor="nombre_usuario" className="block text-sm font-medium text-gray-700 mb-2">
                Usuario
              </label>
              <input
                id="nombre_usuario"
                name="nombre_usuario"
                type="text"
                required
                className="input-field"
                placeholder="Ingresa tu usuario"
                value={credenciales.nombre_usuario}
                onChange={manejarCambio}
                disabled={cargando}
              />
            </div>

            <div>
              <label htmlFor="contrasena" className="block text-sm font-medium text-gray-700 mb-2">
                Contraseña
              </label>
              <input
                id="contrasena"
                name="contrasena"
                type="password"
                required
                className="input-field"
                placeholder="Ingresa tu contraseña"
                value={credenciales.contrasena}
                onChange={manejarCambio}
                disabled={cargando}
              />
            </div>

            <div>
              <button
                type="submit"
                disabled={cargando}
                className="w-full btn-primary flex justify-center items-center"
              >
                {cargando ? (
                  <>
                    <LoadingSpinner size="sm" color="white" />
                    <span className="ml-2">Iniciando sesión...</span>
                  </>
                ) : (
                  'Iniciar Sesión'
                )}
              </button>
            </div>
          </form>

          
        </div>

        <div className="text-center">
          <p className="text-xs text-gray-400">
            © 2024 GoPhone. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login; 